var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Signup succeeded")]),_c('button',{on:{"click":_vm.logOut}},[_vm._v("Log out")]),_c('hr'),_c('img',{staticStyle:{"height":"120px"},attrs:{"src":_vm.photo}}),_c('br'),_c('p',[_vm._v(_vm._s(_vm.name))]),_c('p',[_vm._v(_vm._s(_vm.email))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a095279","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AuthSuccess.vue
// module id = null
// module chunks = 